var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var _copyValue, copyValue_get, _contentTemplate, contentTemplate_get;
import { classMap, ifDefined } from "@horizon/base/directives.js";
import { HznCopyButton } from "@horizon/copy-button";
import { HznInline } from "@horizon/inline";
import { LitElement, html } from "@horizon/base";
import { property, query } from "@horizon/base/decorators.js";
import { ScopedElementsMixin } from "@open-wc/scoped-elements/lit-element.js";
import CopyTextStyles from "./copy-text.css.js";
class HznCopyText extends ScopedElementsMixin(LitElement) {
  constructor() {
    super(...arguments);
    /**
     * @private
     */
    __privateAdd(this, _copyValue);
    /**
     *  @private
     */
    __privateAdd(this, _contentTemplate);
    this.content = "";
    this.copyLabel = "";
    this.highlightCount = 0;
    this.copyHighlighted = false;
    this.hoist = false;
    this.noLetterSpacing = false;
    this.size = "base";
    this.variant = "mono";
  }
  static get scopedElements() {
    return {
      "hzn-copy-button": HznCopyButton,
      "hzn-inline": HznInline
    };
  }
  render() {
    return html`<hzn-inline space="xsmall">
      <p
        class=${classMap({
      "is-letter-spacing-loose": !this.noLetterSpacing,
      "is-letter-spacing-none": this.noLetterSpacing,
      "is-size-base": !(this.size === "small"),
      "is-size-small": Boolean(this.size === "small"),
      "is-variant-body": Boolean(this.variant === "body"),
      "is-variant-mono": !(this.variant === "body")
    })}
      >
          ${__privateGet(this, _contentTemplate, contentTemplate_get)}
      </p>
      <hzn-copy-button
        class="copy-button"
        ?hoist=${this.hoist}
        copy-label="${ifDefined(this.copyLabel)}"
        tone="interactive"
        value="${__privateGet(this, _copyValue, copyValue_get)}"
      ></hzn-copy-button>
    </hzn-inline>`;
  }
}
_copyValue = new WeakSet();
copyValue_get = function() {
  if (!this.copyHighlighted || this.highlightCount <= 0) {
    return this.content;
  }
  return this.content.slice(-this.highlightCount);
};
_contentTemplate = new WeakSet();
contentTemplate_get = function() {
  const normalText = this.content.slice(0, -this.highlightCount);
  const highlightedText = this.content.slice(-this.highlightCount);
  if (this.highlightCount <= 0) {
    return html`${this.content}`;
  } else {
    return html`${normalText}<span class="is-highlight">${highlightedText}</span>`;
  }
};
HznCopyText.styles = [CopyTextStyles];
__decorateClass([
  query(".copy-button")
], HznCopyText.prototype, "innerButton", 2);
__decorateClass([
  property({ type: String })
], HznCopyText.prototype, "content", 2);
__decorateClass([
  property({ type: String, attribute: "copy-label" })
], HznCopyText.prototype, "copyLabel", 2);
__decorateClass([
  property({ type: Number, attribute: "highlight-count" })
], HznCopyText.prototype, "highlightCount", 2);
__decorateClass([
  property({ type: Boolean, attribute: "copy-highlighted" })
], HznCopyText.prototype, "copyHighlighted", 2);
__decorateClass([
  property({ type: Boolean })
], HznCopyText.prototype, "hoist", 2);
__decorateClass([
  property({ type: Boolean, attribute: "no-letter-spacing" })
], HznCopyText.prototype, "noLetterSpacing", 2);
__decorateClass([
  property({ type: String })
], HznCopyText.prototype, "size", 2);
__decorateClass([
  property({ type: String })
], HznCopyText.prototype, "variant", 2);
export {
  HznCopyText
};
//# sourceMappingURL=copy-text.js.map
